import { PhotoOverlayProps } from './PhotoOverlay.types';
import * as S from './PhotoOverlay.styles';

export const PhotoOverlay: React.FC<PhotoOverlayProps> = ({
  overlayText,
  dataTestId,
  zIndex,
  fontSize = 20,
  paddingTop,
}) => {
  return (
    <S.Box data-testid={dataTestId} $zIndex={zIndex}>
      <S.Text $fontSize={fontSize} $paddingTop={paddingTop}>
        {overlayText}
      </S.Text>
    </S.Box>
  );
};
